// Each task row on the run page registers how to change its own status, so the photo check panel can apply
// Jev's suggestions through the same code as ticking the checkbox (permissions, workflow order, notifications).
// Keyed by the published task id (run_checklist.task_id).
export interface RunTaskStatusHandle {
  // Whether the current person may change this task now (assigned, unlocked, not saving)
  canChange: () => boolean;
  // done = true ticks the first status column (e.g. "Completed"); false clears it
  setDone: (done: boolean) => Promise<void>;
  isDone: () => boolean;
  // Ticks the checklist's "Incomplete" (or "Not done") column. Returns false when there is no such column.
  setNotDone: () => Promise<boolean>;
  isNotDone: () => boolean;
  // Clears the "Incomplete" tick (back to no status)
  clearNotDone?: () => Promise<void>;
}

// The status column that means "not done", when the checklist has one (custom columns like
// Completed / Incomplete / Attention Needed / N/A). Never the first column, which means done.
export function findNotDoneIndicator<T extends { id?: string; name?: string }>(
  indicators: T[] | undefined
): T | undefined {
  return (indicators || [])
    .slice(1)
    .find(i => !!i.id && /\b(incomplete|not\s*(done|completed|complete))\b/i.test(i.name || ''));
}

const handles = new Map<string, RunTaskStatusHandle>();

export function registerRunTaskStatus(
  taskId: string,
  handle: RunTaskStatusHandle
) {
  handles.set(taskId, handle);
  return () => {
    if (handles.get(taskId) === handle) handles.delete(taskId);
  };
}

export function getRunTaskStatus(taskId: string) {
  return handles.get(taskId);
}
